import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-indigo-950 group-[.toaster]:text-indigo-50 group-[.toaster]:border-indigo-800 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-indigo-200",
          actionButton:
            "group-[.toast]:bg-indigo-500 group-[.toast]:text-indigo-50",
          cancelButton:
            "group-[.toast]:bg-indigo-800 group-[.toast]:text-indigo-50",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };